import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NotificationsManager.css';
import cs from '../../../components/commonStyle.css';
import {
  Col,
  Row,
  FormGroup,
  FormControl,
  Button
} from 'react-bootstrap';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { toastr } from 'react-redux-toastr';
import NotificationAnalytics from '../../../components/siteadmin/NotificationAnalytics';

class NotificationsManager extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    sendAdminNotification: PropTypes.func.isRequired,
    updateDynamicContent: PropTypes.func.isRequired,
    deleteDynamicContent: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      contentKey: '',
      titleEs: '',
      messageEs: '',
      userId: '',
      isBroadcast: false,
      type: 'marketing',
      actionType: 'explore',
      listingId: '',
      externalUrl: '',
      isLoading: false,
      error: null,
      success: null,
      activeTab: 'analytics',
      editingKey: null, // contentKey being edited
      deleteConfirm: null, // contentKey pending delete confirmation
    };
  }

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox' && name === 'isBroadcast') {
      this.setState({
        isBroadcast: checked,
        userId: checked ? 'ALL_USERS' : ''
      });
    } else {
      this.setState({ [name]: value, error: null, success: null });
    }
  };

  handleSaveContent = async () => {
    const { contentKey, titleEs, messageEs } = this.state;
    const { updateDynamicContent } = this.props;

    if (!contentKey || !titleEs || !messageEs) {
      toastr.warning('Campos requeridos', 'Por favor completa la clave, titulo y mensaje.');
      return;
    }

    this.setState({ isLoading: true, error: null, success: null });

    try {
      const { data } = await updateDynamicContent({
        variables: {
          contentKey,
          contentType: 'notification',
          metaTitle: titleEs,
          content: messageEs,
        }
      });

      if (data?.updateDynamicContent?.status === 'success') {
        toastr.success('Exito', 'Contenido guardado y traducido correctamente.');
        this.setState({
          success: 'Contenido guardado y traducido correctamente.',
          editingKey: null,
        });
        // Refresh templates list
        if (this.props.templatesData && this.props.templatesData.refetch) {
          this.props.templatesData.refetch();
        }
      } else {
        toastr.error('Error', 'Error al guardar el contenido.');
      }
    } catch (err) {
      console.error(err);
      toastr.error('Error', err.message);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleSend = async () => {
    const { userId, contentKey, type, actionType, listingId, externalUrl } = this.state;
    const { sendAdminNotification } = this.props;

    if (!userId || !contentKey) {
      toastr.warning('Campos requeridos', 'Se requiere ID de usuario y Clave de contenido.');
      return;
    }

    this.setState({ isLoading: true, error: null, success: null });

    try {
      const actionVariables = {};
      if (actionType === 'listing' && listingId) {
        actionVariables.id = listingId;
      } else if (actionType === 'url' && externalUrl) {
        actionVariables.url = externalUrl;
      }

      const { data } = await sendAdminNotification({
        variables: {
          userId,
          contentKey,
          type,
          variables: JSON.stringify(actionVariables)
        }
      });

      if (data?.sendAdminNotification) {
        toastr.success('Enviado', `Notificacion enviada al usuario ${userId}`);
        this.setState({ success: 'Notificacion enviada correctamente.' });
      }
    } catch (err) {
      console.error(err);
      toastr.error('Error', err.message);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleEditTemplate = (template) => {
    this.setState({
      contentKey: template.contentKey,
      titleEs: template.metaTitle || '',
      messageEs: template.content || '',
      editingKey: template.contentKey,
      activeTab: 'compose',
    });
  };

  handleUseTemplate = (contentKey) => {
    this.setState({
      contentKey,
      activeTab: 'send',
    });
  };

  handleDeleteTemplate = async (contentKey) => {
    const { deleteDynamicContent } = this.props;
    this.setState({ isLoading: true });

    try {
      const { data } = await deleteDynamicContent({
        variables: {
          contentType: 'notification',
          contentKey,
        }
      });

      if (data?.deleteDynamicContent?.status === 'success') {
        toastr.success('Eliminada', `Plantilla "${contentKey}" eliminada correctamente.`);
        this.setState({ deleteConfirm: null });
        if (this.props.templatesData && this.props.templatesData.refetch) {
          this.props.templatesData.refetch();
        }
      } else {
        toastr.error('Error', data?.deleteDynamicContent?.errorMessage || 'Error al eliminar.');
      }
    } catch (err) {
      console.error(err);
      toastr.error('Error', err.message);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleCancelEdit = () => {
    this.setState({
      contentKey: '',
      titleEs: '',
      messageEs: '',
      editingKey: null,
    });
  };

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  // Group DynamicContent rows by contentKey (only show 'es' locale row info)
  getGroupedTemplates() {
    const { templatesData } = this.props;
    if (!templatesData || templatesData.loading || !templatesData.getAllDynamicContent) {
      return [];
    }

    const all = templatesData.getAllDynamicContent;
    // Group by contentKey
    const grouped = {};
    all.forEach(item => {
      if (!grouped[item.contentKey]) {
        grouped[item.contentKey] = {
          contentKey: item.contentKey,
          locales: [],
          metaTitle: null,
          content: null,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
        };
      }
      grouped[item.contentKey].locales.push(item.locale);
      // Use 'es' locale as the primary info
      if (item.locale === 'es') {
        grouped[item.contentKey].metaTitle = item.metaTitle;
        grouped[item.contentKey].content = item.content;
        grouped[item.contentKey].createdAt = item.createdAt;
        grouped[item.contentKey].updatedAt = item.updatedAt;
      }
    });

    return Object.values(grouped).sort((a, b) => {
      // Sort by updatedAt descending
      const aDate = a.updatedAt || a.createdAt || '';
      const bDate = b.updatedAt || b.createdAt || '';
      return bDate.localeCompare(aDate);
    });
  }

  renderTemplates() {
    const { templatesData } = this.props;
    const { deleteConfirm, isLoading } = this.state;

    if (!templatesData || templatesData.loading) {
      return (
        <div className={s.historyLoading}>
          <div className={s.spinner} />
          <p>Cargando plantillas...</p>
        </div>
      );
    }

    const templates = this.getGroupedTemplates();

    if (templates.length === 0) {
      return (
        <div className={s.noData}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
          </svg>
          <p>No hay plantillas de notificaciones creadas aun.</p>
          <p style={{ fontSize: '12px', marginTop: '8px' }}>
            Ve a la pestaña <strong>Redactar</strong> para crear tu primera plantilla.
          </p>
        </div>
      );
    }

    return (
      <div className={s.historyContainer}>
        <div className={s.historyHeader}>
          <h3 className={s.cardTitle}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            Mis Plantillas de Notificaciones
          </h3>
          <span className={s.historyCount}>{templates.length} plantillas</span>
        </div>

        <div className={s.historyTableWrapper}>
          <table className={s.historyTable}>
            <thead>
              <tr>
                <th>Clave</th>
                <th>Titulo (ES)</th>
                <th>Mensaje (ES)</th>
                <th>Idiomas</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {templates.map((tpl) => {
                const isDeleting = deleteConfirm === tpl.contentKey;

                return (
                  <tr key={tpl.contentKey} className={s.historyRow}>
                    <td>
                      <span className={s.campaignKey} style={{ fontSize: '13px' }}>{tpl.contentKey}</span>
                    </td>
                    <td>
                      <span className={s.campaignTitle}>
                        {tpl.metaTitle || <em style={{ color: '#aaa' }}>Sin titulo ES</em>}
                      </span>
                    </td>
                    <td>
                      <span style={{ fontSize: '13px', color: 'var(--common-content-color)', maxWidth: '250px', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {tpl.content || <em style={{ color: '#aaa' }}>Sin mensaje</em>}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                        {tpl.locales.sort().map(loc => (
                          <span key={loc} className={cx(s.badge, s.badgeSent)} style={{ fontSize: '10px', padding: '2px 6px' }}>
                            {loc === 'es' ? 'ES' : loc === 'en-US' ? 'EN' : loc === 'fr-FR' ? 'FR' : loc === 'it-IT' ? 'IT' : loc === 'pt-PT' ? 'PT' : loc}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td>
                      {isDeleting ? (
                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                          <span style={{ fontSize: '12px', color: '#dc2626', fontWeight: 500 }}>Confirmar?</span>
                          <button
                            className={s.actionBtnDanger}
                            onClick={() => this.handleDeleteTemplate(tpl.contentKey)}
                            disabled={isLoading}
                          >
                            Si, borrar
                          </button>
                          <button
                            className={s.actionBtn}
                            onClick={() => this.setState({ deleteConfirm: null })}
                          >
                            No
                          </button>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button
                            className={s.actionBtn}
                            onClick={() => this.handleEditTemplate(tpl)}
                            title="Editar plantilla"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                            Editar
                          </button>
                          <button
                            className={s.actionBtnGreen}
                            onClick={() => this.handleUseTemplate(tpl.contentKey)}
                            title="Usar esta plantilla para enviar"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
                            </svg>
                            Enviar
                          </button>
                          <button
                            className={s.actionBtnDanger}
                            onClick={() => this.setState({ deleteConfirm: tpl.contentKey })}
                            title="Eliminar plantilla"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <polyline points="3 6 5 6 21 6" />
                              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                            </svg>
                            Borrar
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    const { contentKey, titleEs, messageEs, userId, isBroadcast, type, actionType, listingId, externalUrl, isLoading, activeTab, editingKey } = this.state;

    return (
      <div className={cx(cs.adminContentPadding)}>
        <div className={s.headerSection}>
          <h1 className={cx(cs.commonTitleText, cs.fontWeightBold)}>
            Gestor de Notificaciones
          </h1>
          <p className={s.headerSubtitle}>
            Crea, programa y analiza tus notificaciones push con inteligencia artificial
          </p>
        </div>

        {/* Tabs */}
        <div className={s.tabsContainer}>
          <button
            className={cx(s.tab, activeTab === 'analytics' && s.tabActive)}
            onClick={() => this.setActiveTab('analytics')}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 20V10M12 20V4M6 20v-6" />
            </svg>
            Engagement Insights
          </button>
          <button
            className={cx(s.tab, activeTab === 'templates' && s.tabActive)}
            onClick={() => this.setActiveTab('templates')}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            Mis Plantillas
          </button>
          <button
            className={cx(s.tab, activeTab === 'compose' && s.tabActive)}
            onClick={() => this.setActiveTab('compose')}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
            </svg>
            {editingKey ? 'Editando' : 'Redactar'}
          </button>
          <button
            className={cx(s.tab, activeTab === 'send' && s.tabActive)}
            onClick={() => this.setActiveTab('send')}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
            </svg>
            Enviar
          </button>
        </div>

        {/* Analytics Tab */}
        {activeTab === 'analytics' && (
          <div className={s.tabContent}>
            <NotificationAnalytics />
          </div>
        )}

        {/* Templates Tab */}
        {activeTab === 'templates' && (
          <div className={s.tabContent}>
            {this.renderTemplates()}
          </div>
        )}

        {/* Compose Tab */}
        {activeTab === 'compose' && (
          <div className={s.tabContent}>
            <div className={s.card}>
              <div className={s.cardHeader}>
                <h3 className={s.cardTitle}>
                  {editingKey
                    ? <span>Editando: <code style={{ fontSize: '14px', background: '#f1f5f9', padding: '2px 8px', borderRadius: '4px' }}>{editingKey}</code></span>
                    : 'Redactar Notificacion'
                  }
                </h3>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <span className={s.cardBadge}>Auto-traduccion IA</span>
                  {editingKey && (
                    <button
                      onClick={this.handleCancelEdit}
                      style={{
                        background: 'none',
                        border: '1px solid #e2e8f0',
                        borderRadius: '6px',
                        padding: '4px 12px',
                        fontSize: '12px',
                        cursor: 'pointer',
                        color: '#64748b'
                      }}
                    >
                      Cancelar edicion
                    </button>
                  )}
                </div>
              </div>
              <div className={s.cardBody}>
                <Row>
                  <Col md={12}>
                    <FormGroup className={s.formGroup}>
                      <label className={s.label}>Clave Unica (ID interno)</label>
                      <FormControl
                        type="text"
                        name="contentKey"
                        value={contentKey}
                        placeholder="ej. promo_verano_2025"
                        onChange={this.handleInputChange}
                        className={s.input}
                        disabled={!!editingKey}
                      />
                      <span className={s.helpText}>
                        {editingKey
                          ? 'La clave no puede cambiarse al editar. Para usar otra clave, crea una nueva.'
                          : 'Esta clave identifica la notificacion en la base de datos'
                        }
                      </span>
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className={s.formGroup}>
                      <label className={s.label}>Titulo (Español)</label>
                      <FormControl
                        type="text"
                        name="titleEs"
                        value={titleEs}
                        placeholder="Oferta especial de verano!"
                        onChange={this.handleInputChange}
                        className={s.input}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className={s.formGroup}>
                      <label className={s.label}>Mensaje (Español)</label>
                      <FormControl
                        componentClass="textarea"
                        name="messageEs"
                        value={messageEs}
                        placeholder="Escribe el cuerpo de la notificacion..."
                        rows={4}
                        onChange={this.handleInputChange}
                        className={s.textarea}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <div className={s.cardFooter}>
                  <Button
                    className={cx(cs.btnPrimary, s.submitBtn)}
                    onClick={this.handleSaveContent}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Procesando...' : (editingKey ? 'Actualizar y Traducir' : 'Guardar y Traducir')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Send Tab */}
        {activeTab === 'send' && (
          <div className={s.tabContent}>
            <div className={s.card}>
              <div className={s.cardHeader}>
                <h3 className={s.cardTitle}>Enviar Notificacion</h3>
              </div>
              <div className={s.cardBody}>
                <Row>
                  <Col md={12}>
                    <FormGroup className={s.formGroup}>
                      <div className={s.broadcastWrapper} style={{ marginBottom: '10px' }}>
                        <label className={s.checkboxLabel}>
                          <input
                            type="checkbox"
                            name="isBroadcast"
                            checked={isBroadcast}
                            onChange={this.handleInputChange}
                            style={{ marginRight: '8px' }}
                          />
                          <strong>Enviar masivamente a TODOS los usuarios (Broadcast)</strong>
                        </label>
                      </div>

                      <label className={s.label}>ID del Usuario o Email</label>
                      <FormControl
                        type="text"
                        name="userId"
                        value={userId}
                        placeholder={isBroadcast ? "TODOS LOS USUARIOS" : "UUID o email (ej. usuario@navega.com)"}
                        onChange={this.handleInputChange}
                        className={s.input}
                        disabled={isBroadcast}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className={s.formGroup}>
                      <label className={s.label}>Clave de Contenido</label>
                      <FormControl
                        type="text"
                        name="contentKey"
                        value={contentKey}
                        placeholder="ej. promo_verano_2025"
                        onChange={this.handleInputChange}
                        className={s.input}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className={s.formGroup}>
                      <label className={s.label}>Tipo de Notificacion</label>
                      <div className={s.radioGroup}>
                        <label className={s.radioOption}>
                          <input
                            type="radio"
                            name="type"
                            value="marketing"
                            checked={type === 'marketing'}
                            onChange={this.handleInputChange}
                          />
                          <span className={s.radioLabel}>Marketing</span>
                        </label>
                        <label className={s.radioOption}>
                          <input
                            type="radio"
                            name="type"
                            value="high_priority"
                            checked={type === 'high_priority'}
                            onChange={this.handleInputChange}
                          />
                          <span className={s.radioLabel}>Alta Prioridad</span>
                        </label>
                        <label className={s.radioOption}>
                          <input
                            type="radio"
                            name="type"
                            value="transactional"
                            checked={type === 'transactional'}
                            onChange={this.handleInputChange}
                          />
                          <span className={s.radioLabel}>Transaccional</span>
                        </label>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className={s.formGroup}>
                      <label className={s.label}>Accion al Tocar Notificacion</label>
                      <div className={s.radioGroup}>
                        <label className={s.radioOption}>
                          <input
                            type="radio"
                            name="actionType"
                            value="explore"
                            checked={actionType === 'explore'}
                            onChange={this.handleInputChange}
                          />
                          <span className={s.radioLabel}>Ir a Explore (Home)</span>
                        </label>
                        <label className={s.radioOption}>
                          <input
                            type="radio"
                            name="actionType"
                            value="listing"
                            checked={actionType === 'listing'}
                            onChange={this.handleInputChange}
                          />
                          <span className={s.radioLabel}>Abrir Listing Especifico</span>
                        </label>
                        <label className={s.radioOption}>
                          <input
                            type="radio"
                            name="actionType"
                            value="url"
                            checked={actionType === 'url'}
                            onChange={this.handleInputChange}
                          />
                          <span className={s.radioLabel}>Abrir URL Externa</span>
                        </label>
                      </div>
                    </FormGroup>
                  </Col>
                  {actionType === 'listing' && (
                    <Col md={12}>
                      <FormGroup className={s.formGroup}>
                        <label className={s.label}>ID del Listing</label>
                        <FormControl
                          type="text"
                          name="listingId"
                          value={listingId}
                          placeholder="ej. 82"
                          onChange={this.handleInputChange}
                          className={s.input}
                        />
                        <span className={s.helpText}>El ID numerico del listing que se abrira</span>
                      </FormGroup>
                    </Col>
                  )}
                  {actionType === 'url' && (
                    <Col md={12}>
                      <FormGroup className={s.formGroup}>
                        <label className={s.label}>URL Externa</label>
                        <FormControl
                          type="text"
                          name="externalUrl"
                          value={externalUrl}
                          placeholder="https://navega.com/promo-verano"
                          onChange={this.handleInputChange}
                          className={s.input}
                        />
                        <span className={s.helpText}>Se abrira en el navegador del dispositivo</span>
                      </FormGroup>
                    </Col>
                  )}
                </Row>

                <div className={s.infoBox}>
                  <div className={s.infoItem}>
                    <strong>Marketing:</strong> Bloqueado si se envio otro en 48h. Optimizado por IA para horas no-molestas.
                  </div>
                  <div className={s.infoItem}>
                    <strong>Alta Prioridad:</strong> Se envia siempre inmediatamente (seguridad, reservas).
                  </div>
                  <div className={s.infoItem}>
                    <strong>Transaccional:</strong> Confirmaciones y actualizaciones de estado.
                  </div>
                </div>

                <div className={s.cardFooter}>
                  <Button
                    className={cx(cs.btnPrimary, s.submitBtn, s.submitBtnGreen)}
                    onClick={this.handleSend}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Enviando...' : 'Enviar Notificacion'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const sendNotificationMutation = gql`
  mutation sendAdminNotification($userId: String!, $contentKey: String!, $variables: String, $type: String) {
    sendAdminNotification(userId: $userId, contentKey: $contentKey, variables: $variables, type: $type)
  }
`;

const updateContentMutation = gql`
  mutation updateDynamicContent(
    $contentKey: String!, 
    $contentType: String!,
    $metaTitle: String,
    $content: String
  ) {
    updateDynamicContent(
      contentKey: $contentKey, 
      contentType: $contentType,
      metaTitle: $metaTitle,
      content: $content
    ) {
      status
    }
  }
`;

const deleteContentMutation = gql`
  mutation deleteDynamicContent($contentType: String!, $contentKey: String!) {
    deleteDynamicContent(contentType: $contentType, contentKey: $contentKey) {
      status
      errorMessage
    }
  }
`;

const getTemplatesQuery = gql`
  query getAllDynamicContent($contentType: String, $locale: String) {
    getAllDynamicContent(contentType: $contentType, locale: $locale) {
      id
      contentType
      contentKey
      locale
      metaTitle
      content
      isActive
      createdAt
      updatedAt
    }
  }
`;

export default compose(
  injectIntl,
  withStyles(s, cs),
  graphql(sendNotificationMutation, { name: 'sendAdminNotification' }),
  graphql(updateContentMutation, { name: 'updateDynamicContent' }),
  graphql(deleteContentMutation, { name: 'deleteDynamicContent' }),
  graphql(getTemplatesQuery, {
    name: 'templatesData',
    options: {
      variables: { contentType: 'notification' },
      fetchPolicy: 'network-only'
    }
  })
)(NotificationsManager);
